import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { toCssClass } from 'helpers'

import { UNIT_TYPES } from 'constants'

import { Status, Options, BattleTitle } from '../../components'

import { BATTLE_LIST_CAPTIONS } from './constants.jsx'

import styles from './Battle.scss'

const Battle = (props) => {
    const optionsComponent = props.type === UNIT_TYPES.SORTIE ? null : (
        <Options battleRegulations={props.battleRegulations} inline />
    )

    const buttons = props.children.map((component, idx) => (
        <div className={styles.item} key={`${props.type}-button-${idx}`}>
            {component}
        </div>
    ))

    const className = classNames(styles.base, styles[`base__${toCssClass(props.type)}`])

    return (
        <div className={className}>
            <div className={styles.header}>
                <BattleTitle type={props.type} />
            </div>
            <Status
                primetimeStart={props.primetimeStart}
                primetimeEnd={props.primetimeEnd}
                type={props.type}
                isAvailable
            />
            {optionsComponent}
            <p className={styles.caption}>{BATTLE_LIST_CAPTIONS[props.type]}</p>
            <div className={styles.list}>
                {buttons}
            </div>
        </div>
    )
}

Battle.propTypes = {
    type: PropTypes.oneOf(Object.values(UNIT_TYPES)).isRequired,
    children: PropTypes.array.isRequired,
    battleRegulations: PropTypes.object,
    primetimeStart: PropTypes.number,
    primetimeEnd: PropTypes.number,
}

export default Battle



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Battle/Battle.jsx